export default {
  activePresetData: (state) => {
    return state.report.presets.find(preset=>preset.presetId===state.report.activePreset)   
  },
};
